<template>
  <div id="app">
    <nav class="clear">
      <div class="menu">

        <a href="/">
          <img class="logo" :src="$img( 'logo.png' )" />
        </a>

        <div class="list" id="menu">
          <a data-menuanchor="home" class="link" href='/#home'>首页</a>
          <a data-menuanchor="about" class="link" href='/#about'>犬舍介绍</a>
          <a data-menuanchor="champion" class="link" href='#champion'>冠军犬只</a>
          <a data-menuanchor="sale" class="link" href='/#sale'>代售幼犬</a>
          <a data-menuanchor="protocol" class="link" href='/#protocol'>购买协议</a>
          <a data-menuanchor="consult" class="link" href='/#consult'>赛场资讯</a>
          <a data-menuanchor="contact" class="link" href='/#contact'>联系我们</a>
        </div>

        <div class="qcore" @mouseover="sqc" @mouseout="hqc">
          <img :src="$img('e1.png')" />
          <img v-show="qc" class="max-qc" :src="$img('e2.png')" />
        </div>

      </div>
      <div class="border"></div>
    </nav>
    <router-view class="router_view"></router-view>

    <footer v-if="config">
      ©2017-2020 g-yorkies <a href="http://www.beian.gov.cn/" target="_blank">粤ICP备17032449号</a> <span>访问人数：{{config.number}}</span> 友情链接：<a v-for="(item, index) in link" :key="index" :href="item.href" target="_blank">{{item.title}}</a>
    </footer>
  </div>
</template>

<script>

export default {
  name: 'app',
  data () {
    return {
      config: null,
      link: null,
      qc: false
    }
  },
  created () {
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
      window.location.href = 'http://h5.g-yorkies.com'
      return
		}
    this.init()
  },
  methods: {
    sqc () {
      this.qc = true
    },
    hqc () {
      this.qc = false
    },
    init () {
      this.$api('GET', '/index').then(res => {
        console.log(res)
        this.link = res.data.link
        this.config = res.data.config
      })
    }
  }
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

a {
  text-decoration: none;
  color: #2c3e50;
}

html, body {
  height: 100%;
  background: #eee;
  min-width: 1326px;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clear {
  &::after {
    content: '';
    display: block;
    clear: both;
  }
}

nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 200px;
  height: 100%;
  z-index: 2;
  .menu {
    position: relative;
    padding: 30px;
    float: left;
    width: calc(100% - 24px);
    height: 100%;
    background: #fff;
    .logo {
      display: block;
      margin: 0 auto 33px;
    }
    .list {
      text-align: center;
      .link {
        transition: all 200ms;
        text-decoration: none;
        color: #2c3e50;
        display: block;
        font-size: 16px;
        line-height: 54px;
      }
      .active {
        color: #be8b41;
      }
    }
    .qcore {
      position: absolute;
      bottom: 10px;
      width: 56px;
      left: 75px;
      .max-qc {
        position: absolute;
        right: -111px;
        bottom: 0px;
        width: 120px;
      }
    }
  }
  .border {
    float: right;
    width: 24px;
    height: 100%;
    background: url('./assets/images/nav_border.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
}

.router_view {
  position: fixed;
  width: calc( 100% - 170px );
  right: 0;
  top: 0;
  height: 100%;
  background: #fff;
}

footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 46px;
  line-height: 46px;
  background: #fff;
  text-indent: 200px;
  text-align: center;
  font-size: 14px;
  span {
    padding: 0 20px;
  }
  a {
    text-decoration: none;
    margin-left: 10px;
    color: #2c3e50;
  }
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
